import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useField } from "formik";

// component
import LdsValidationError from "../LdsValidationError";
import { ReactLoaderSpinner } from "../ReactLoaderSpinner";

// services
import { useGetStateQuery } from "../../store/services/locationServerApi";

export const StateDropDown = ({ label, labelRequired, name, error }) => {
  const [field, meta, helpers] = useField(name);

  // useState
  const [stateOptions, setStateOptions] = useState([]);

  // RTK call
  const { isLoading, data: { data: stateList = [] } = {} } = useGetStateQuery();

  useEffect(() => {
    if (stateList?.length) {
      const stateOptions = stateList?.map(({ code: value, name: label }) => ({
        value,
        label,
      }));
      setStateOptions(stateOptions);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateList]);

  return (
    <>
      {isLoading && <ReactLoaderSpinner />}
      {label && (
        <label className="lds-form-label">
          {label} {labelRequired && <span className="required"> *</span>}
        </label>
      )}
      <Select
        name={name}
        value={field.value}
        options={stateOptions}
        onChange={(value) => helpers.setValue(value)}
        onBlur={() => helpers.setTouched(true)}
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            borderColor: error ? "red" : "grey",
          }),
        }}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary25: "#d9e1ea",
            primary: "#7393B3",
          },
        })}
      />
      {error && <LdsValidationError id="errstate">{error}</LdsValidationError>}
    </>
  );
};
